/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Draggable } from 'components/drag-and-drop';
import { Brikk } from 'components/Brikk';
import { SocketIcon } from 'assets/icons/brikks/SocketIcon';
import { SeeMoreButton } from 'components/form-elements/buttons/SeeMoreButton';
// import { DemoModal } from 'components/modals/DemoModal';
import { BrikkInfoModal } from 'components/modals/BrikkInfoModal';
import { InfoButton } from 'components/form-elements/buttons/InfoButton';
import { EnergyNetData } from './components/EnergyNetData';

export const EnergyPort = ({ position, status, code, name }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [viewDate, setViewDate] = useState('2023-01-01 09:00:00.000');

  const handleDateChange = (e) => {
    setViewDate(e.target.value);
  };

  const handleInfoModal = (e) => {
    e.stopPropagation();
    setIsInfoModalOpen(!isInfoModalOpen);
  };

  const handleOpenModal = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <Draggable position={position}>
        <Brikk
          brikkKey={code}
          name={name}
          status={status}
        >
          <Brikk.Header
            icon={<SocketIcon />}
            heading="electricitySustainabilityBrikk"
            brikkKey={code}
            status={status}
          />
          <Brikk.Content>
            <input
              id="datepicker"
              type="datetime-local"
              value={viewDate}
              onChange={handleDateChange}
            />
            <EnergyNetData fromTime={viewDate} />
          </Brikk.Content>

          <Brikk.Button>
            <SeeMoreButton
              onClick={handleOpenModal}
              brikkNameIntl="electricity"
            />
            <InfoButton
              showModal={isInfoModalOpen}
              onClick={handleInfoModal}
            />
          </Brikk.Button>
        </Brikk>
      </Draggable>

      <BrikkInfoModal
        title="Electricity info"
        // info={info}
        showModal={isInfoModalOpen}
        onClick={() => setIsInfoModalOpen(!isInfoModalOpen)}
      />
    </>
  );
};
